// extracted by mini-css-extract-plugin
export default {"aglmd-error-fallback__title":"cnJfDPgWgSQUJ8PsoTL7"};